import { createRouter, createWebHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';
import { fetchPrincipal, signInUrl, useUserStore } from '@/scripts/auth';

/**
 * Vue Router instance. Routes come from `src/pages/**` via the `vue-router/vite` file-based-routing
 * plugin; the `beforeEach` guard fetches the SWA Entra principal and redirects anonymous users to
 * the AAD sign-in flow. Routes opt out by setting `meta.auth = false` (see error pages).
 */
export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  try {
    if (to.meta.auth === false) return true;
    const principal = await fetchPrincipal();
    if (!principal) {
      window.location.href = signInUrl(to.fullPath);
      return false;
    }
    const userStore = useUserStore();
    await userStore.Reload();
    return true;
  } catch (e) {
    console.error('Navigation guard failed', e);
    return '/error/500';
  }
});
